/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Math.Fuzzy
 */

module.exports = {

    Ceil: require('./Ceil'),
    Equal: require('./Equal'),
    Floor: require('./Floor'),
    GreaterThan: require('./GreaterThan'),
    LessThan: require('./LessThan')

};



//////////////////
// WEBPACK FOOTER
// ./math/fuzzy/index.js
// module id = 824
// module chunks = 0